import { forwardRef } from "react";

import Box, { BoxProps } from "@mui/material/Box";

import { mergeSx } from "@/common/helpers/mergeSx";

type ChartLegendDotProps = {
  backgroundColor: string;
} & Omit<BoxProps, "width" | "height" | "borderRadius">;

export const ChartLegendDot = forwardRef<HTMLDivElement, ChartLegendDotProps>(
  ({ backgroundColor, sx, ...props }, ref) => {
    return (
      <Box
        {...props}
        ref={ref}
        width={16}
        height={16}
        borderRadius="50%"
        sx={mergeSx({ backgroundColor, transition: "background-color 200ms linear" }, sx)}
      />
    );
  }
);

ChartLegendDot.displayName = "ChartLegendDot";
